import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormTech } from "../Form";
import ButtonStyle from "../Link";
import ModalStyle from "./style";
import { techSchema } from "../../services/schema/techSchema";
import WarningText from "../Warnings";
import { useState } from "react";
import { useTechProvider } from "../../contexts/TechContext";

interface iModal {
  closeModal: () => void
}

export interface iModalRegister {
  title: string;
  status: string;
}


const Modal = ({ closeModal }: iModal) => {
  const { newTech } = useTechProvider();
  const [loadButton, setLoadButton] = useState(false);


  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<iModalRegister>({
    resolver: yupResolver(techSchema),
  });

  const registerTech = (data: iModalRegister) => {
    newTech(data, setLoadButton, closeModal);
  };

  return (
    <ModalStyle>
      <FormTech onSubmit={handleSubmit(registerTech)}>
        <header>
          <h3>Cadastrar Tecnologia</h3>
          <button type="button" onClick={() => closeModal()}>
            X
          </button>
        </header>
        <div>
          <div className="infosInput">
            <label htmlFor="title">Nome</label>
            <input
              id="title"
              type="text"
              placeholder="Digite a tecnoliga"
              {...register("title")}
            />
            <WarningText>{errors.title?.message}</WarningText>
          </div>
          <div className="infosInput">
            <label htmlFor="status">Selecionar status</label>
            <select id="status" {...register("status")}>
              <option value="Iniciante">Iniciante</option>
              <option value="Intermediario">Intermediario</option>
              <option value="Avançado">Avançado</option>
            </select>
          </div>
          <ButtonStyle type="submit" className="login" disabled={loadButton}>
            {!loadButton ? "Cadastrar Tecnologia" : "Cadastrando..."}
          </ButtonStyle>
        </div>
      </FormTech>
    </ModalStyle>
  );
};

export default Modal;
